<template>
    <div class="consultation-page" :style="{ marginTop: this.GLOBAL.isMobile ? '60px' : '0' }">
        <div class="consultation-shell">
            <section class="hero-card">
                <div class="hero-copy">
                    <h1>{{ $t('consultation_page_title') }}</h1>
                    <p>{{ $t('consultation_subtitle') }}</p>
                </div>
                <div class="hero-points">
                    <div class="point-card" v-for="(item, index) in advantageList" :key="item.title">
                        <span class="point-index">0{{ index + 1 }}</span>
                        <h3>{{ item.title }}</h3>
                        <p>{{ item.desc }}</p>
                    </div>
                </div>
            </section>

            <section class="content-grid">
                <div class="info-card">
                    <div class="card-head">
                        <h2>{{ $t('consultation_info_title') }}</h2>
                    </div>
                    <div class="info-list">
                        <div class="info-item" v-for="item in communicationList" :key="item.title">
                            <i></i>
                            <div>
                                <h4>{{ item.title }}</h4>
                                <p>{{ item.desc }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="contact-tip">
                        {{ $t('consultation_helper') }}
                    </div>
                </div>

                <div class="form-card">
                    <div class="card-head">
                        <h2>{{ $t('consultation_form_title') }}</h2>
                        <p>{{ $t('consultation_form_desc') }}</p>
                    </div>
                    <div v-if="formLabelAlign.productName" class="prefill-tag">
                        {{ $t('consultation_prefill') }}: {{ formLabelAlign.productName }}
                    </div>
                    <el-form
                        class="consultation-form"
                        :label-position="formLabelPosition"
                        label-width="150px"
                        :model="formLabelAlign"
                    >
                        <el-form-item :label="$t('consultation_company_label')">
                            <el-input
                                v-model="formLabelAlign.custName"
                                :placeholder="$t('consultation_company_placeholder')"
                            ></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('consultation_product_label')">
                            <el-input
                                v-model="formLabelAlign.productName"
                                :placeholder="$t('consultation_product_placeholder')"
                            ></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('consultation_contact_label')">
                            <el-input
                                v-model="formLabelAlign.phone"
                                :placeholder="$t('consultation_contact_placeholder')"
                            ></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('consultation_requirement_label')">
                            <el-input
                                v-model="formLabelAlign.content"
                                type="textarea"
                                rows="5"
                                :placeholder="$t('consultation_requirement_placeholder')"
                            ></el-input>
                        </el-form-item>
                        <div class="form-actions">
                            <el-button :loading="submitLoading" type="primary" @click="submit">
                                {{ $t('consultation_submit') }}
                            </el-button>
                        </div>
                    </el-form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import axios from '@/utils/axios'

export default {
    data() {
        return {
            submitLoading: false,
            formLabelAlign: {
                custName: '',
                productName: '',
                phone: '',
                content: '',
                type: 'XMHZ'
            },
        }
    },
    computed: {
        formLabelPosition() {
            const locale = this.$i18n && this.$i18n.locale ? String(this.$i18n.locale).toUpperCase() : 'CN'
            return this.GLOBAL.isMobile || locale !== 'CN' ? 'top' : 'left'
        },
        advantageList() {
            return [
                {
                    title: this.$t('consultation_advantage_1_title'),
                    desc: this.$t('consultation_advantage_1_desc')
                },
                {
                    title: this.$t('consultation_advantage_2_title'),
                    desc: this.$t('consultation_advantage_2_desc')
                },
                {
                    title: this.$t('consultation_advantage_3_title'),
                    desc: this.$t('consultation_advantage_3_desc')
                }
            ]
        },
        communicationList() {
            return [
                {
                    title: this.$t('consultation_focus_1_title'),
                    desc: this.$t('consultation_focus_1_desc')
                },
                {
                    title: this.$t('consultation_focus_2_title'),
                    desc: this.$t('consultation_focus_2_desc')
                },
                {
                    title: this.$t('consultation_focus_3_title'),
                    desc: this.$t('consultation_focus_3_desc')
                }
            ]
        }
    },
    methods: {
        submit() {
            if (this.submitLoading) return
            this.submitLoading = true
            axios.post('/jyy/portal/addConsultation', this.formLabelAlign)
                .then((res) => {
                    const data = res.data || {}
                    if (data.code === 0) {
                        this.$message({
                            message: data.msg,
                            showClose: true,
                            center: true,
                            duration: 5000,
                            type: 'success',
                        })
                        this.$router.back()
                        return
                    }
                    this.$message({
                        message: data.msg,
                        showClose: true,
                        center: true,
                        duration: 5000,
                        type: 'warning',
                    })
                })
                .catch(() => {
                    this.$message({
                        message: this.$t('consultation_submit_error'),
                        showClose: true,
                        center: true,
                        duration: 5000,
                        type: 'error',
                    })
                })
                .then(() => {
                    this.submitLoading = false
                })
        },
    },
    mounted() {
        const productName = this.$route.query && this.$route.query.name
        this.formLabelAlign.productName = productName || ''
    },
}
</script>

<style lang="less" scoped>
.consultation-page {
    --primary: #0a3569;
    --primary-light: #2f6ed1;
    --deep: #041a33;
    --text: #112136;
    --muted: #627286;
    --line: #d9e4f0;
    padding: 42px 0 72px;
    background: linear-gradient(180deg, #f9fbff 0%, #eef4fb 100%);
    color: var(--text);
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.consultation-shell {
    width: min(1200px, calc(100% - 40px));
    margin: 0 auto;
}

.hero-card {
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 1.08fr) minmax(0, 1fr);
    gap: 24px;
    padding: 36px;
    border-radius: 28px;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0 18px 54px rgba(16, 44, 88, 0.12);
}

.hero-card::before {
    content: '';
    position: absolute;
    inset: 0 auto 0 0;
    width: 45%;
    background: linear-gradient(135deg, #0a315e 0%, #0f4f96 100%);
}

.hero-card::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 45%;
    height: 100%;
    background:
        radial-gradient(circle at 18% 28%, rgba(255, 255, 255, 0.18) 0, rgba(255, 255, 255, 0) 48%),
        radial-gradient(circle at 82% 72%, rgba(255, 255, 255, 0.14) 0, rgba(255, 255, 255, 0) 44%);
    pointer-events: none;
}

.hero-copy,
.hero-points {
    position: relative;
    z-index: 1;
}

.hero-copy {
    padding: 10px 8px 10px 4px;
    color: #ffffff;
}

.card-tag {
    display: inline-flex;
    align-items: center;
    min-height: 30px;
    padding: 0 14px;
    border-radius: 999px;
    font-size: 12px;
    letter-spacing: 1px;
}

.hero-copy h1 {
    margin: 0 0 18px;
    font-size: clamp(30px, 3vw, 48px);
    font-weight: 600;
    line-height: 1.2;
}

.hero-copy p {
    margin: 0;
    max-width: 480px;
    line-height: 1.9;
    color: rgba(255, 255, 255, 0.88);
    font-size: 15px;
}

.hero-points {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    align-content: center;
}

.point-card {
    min-height: 190px;
    padding: 22px 20px;
    border-radius: 20px;
    background: linear-gradient(180deg, #f7fbff 0%, #ffffff 100%);
    border: 1px solid rgba(24, 77, 147, 0.08);
    box-shadow: 0 14px 36px rgba(16, 44, 88, 0.08);
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.point-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 18px 42px rgba(16, 44, 88, 0.12);
}

.point-index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 12px;
    background: rgba(47, 110, 209, 0.1);
    color: #1b4e98;
    font-size: 14px;
    font-weight: 700;
}

.point-card h3 {
    margin: 18px 0 12px;
    font-size: 18px;
    color: var(--text);
}

.point-card p {
    margin: 0;
    color: var(--muted);
    line-height: 1.75;
    font-size: 14px;
}

.content-grid {
    display: grid;
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
    gap: 24px;
    margin-top: 24px;
}

.info-card,
.form-card {
    background: #ffffff;
    border-radius: 24px;
    padding: 34px 32px;
    box-shadow: 0 16px 48px rgba(16, 44, 88, 0.1);
}

.card-tag {
    background: rgba(10, 53, 105, 0.08);
    color: #1a4e97;
}

.card-head h2 {
    margin: 16px 0 0;
    font-size: clamp(26px, 2.2vw, 34px);
    line-height: 1.35;
}

.card-head p {
    margin: 14px 0 0;
    color: var(--muted);
    line-height: 1.8;
}

.info-list {
    display: grid;
    gap: 18px;
    margin-top: 28px;
}

.info-item {
    display: flex;
    gap: 14px;
    padding-bottom: 18px;
    border-bottom: 1px solid var(--line);
}

.info-item:last-child {
    padding-bottom: 0;
    border-bottom: none;
}

.info-item i {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-top: 9px;
    flex-shrink: 0;
    background: linear-gradient(135deg, #2b67c4 0%, #46a2ff 100%);
    box-shadow: 0 0 0 6px rgba(70, 162, 255, 0.12);
}

.info-item h4 {
    margin: 0 0 8px;
    font-size: 18px;
    color: var(--text);
}

.info-item p {
    margin: 0;
    color: var(--muted);
    line-height: 1.75;
}

.contact-tip {
    margin-top: 28px;
    padding: 18px 20px;
    border-radius: 18px;
    background: linear-gradient(135deg, #edf4ff 0%, #f8fbff 100%);
    color: var(--muted);
    line-height: 1.8;
}

.prefill-tag {
    display: inline-flex;
    align-items: center;
    min-height: 36px;
    margin-top: 22px;
    padding: 0 16px;
    border-radius: 999px;
    background: rgba(10, 53, 105, 0.06);
    color: #1a4e97;
    font-size: 13px;
}

.consultation-form {
    margin-top: 26px;
}

.consultation-page ::v-deep .el-form-item {
    margin-bottom: 22px;
}

.consultation-page ::v-deep .el-form-item__label {
    color: var(--text);
    font-size: 15px;
    font-weight: 500;
    line-height: 48px;
    padding-right: 18px;
}

.consultation-page ::v-deep .el-input,
.consultation-page ::v-deep .el-textarea {
    width: 90%;
}

.consultation-page ::v-deep .el-form-item.is-error .el-input__inner,
.consultation-page ::v-deep .el-form-item.is-error .el-textarea__inner {
    border-color: #f56c6c;
}

.consultation-page ::v-deep .el-input__inner,
.consultation-page ::v-deep .el-textarea__inner {
    border-radius: 14px;
    border: 1px solid #d6e1ee;
    background: #fbfdff;
    color: var(--text);
    transition: border-color 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease;
}

.consultation-page ::v-deep .el-input__inner {
    height: 48px;
    line-height: 48px;
}

.consultation-page ::v-deep .el-textarea__inner {
    min-height: 150px !important;
    line-height: 1.8;
    padding-top: 12px;
}

.consultation-page ::v-deep .el-input__inner::placeholder,
.consultation-page ::v-deep .el-textarea__inner::placeholder {
    color: #97a6b8;
}

.consultation-page ::v-deep .el-input__inner:hover,
.consultation-page ::v-deep .el-textarea__inner:hover {
    border-color: #a9c1df;
}

.consultation-page ::v-deep .el-input__inner:focus,
.consultation-page ::v-deep .el-textarea__inner:focus {
    border-color: #2f6ed1;
    background: #ffffff;
    box-shadow: 0 0 0 4px rgba(47, 110, 209, 0.12);
}

.form-actions {
    padding-top: 6px;
    padding-left: 150px;
    display: flex;
    justify-content: flex-end;
}

.form-actions .el-button {
    margin-right: 40px;
    min-width: 158px;
    min-height: 46px;
    padding: 0 30px;
    border: none;
    border-radius: 999px;
    background: linear-gradient(90deg, #0d4b93 0%, #2f6ed1 100%);
    box-shadow: 0 12px 28px rgba(26, 82, 176, 0.24);
    font-size: 15px;
    font-weight: 600;
    transition: transform 0.22s ease, box-shadow 0.22s ease, opacity 0.22s ease;
}

.form-actions .el-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 32px rgba(26, 82, 176, 0.28);
}

.form-actions .el-button.is-loading,
.form-actions .el-button:active {
    transform: none;
}

@media screen and (max-width: 1100px) {
    .hero-card {
        grid-template-columns: 1fr;
    }

    .hero-card::before,
    .hero-card::after {
        width: 100%;
        height: 44%;
    }

    .hero-card::before {
        inset: 0 0 auto 0;
    }

    .hero-card::after {
        inset: 0 0 auto 0;
    }

    .hero-copy {
        padding: 6px 2px 8px;
    }

    .hero-points {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .content-grid {
        grid-template-columns: 1fr;
    }
}

@media screen and (max-width: 900px) {
    .hero-points {
        grid-template-columns: 1fr;
    }

    .point-card {
        min-height: auto;
    }
}

@media screen and (max-width: 768px) {
    .consultation-page {
        padding: 22px 0 48px;
    }

    .consultation-shell {
        width: calc(100% - 24px);
    }

    .hero-card,
    .info-card,
    .form-card {
        padding: 24px 18px;
        border-radius: 20px;
    }

    .hero-card::before,
    .hero-card::after {
        height: 38%;
    }

    .hero-copy p {
        max-width: none;
        font-size: 14px;
    }

    .consultation-page ::v-deep .el-form-item__label {
        line-height: 1.6;
        padding-right: 0;
        padding-bottom: 8px;
    }

    .consultation-page ::v-deep .el-input,
    .consultation-page ::v-deep .el-textarea {
        width: 100%;
    }

    .form-actions {
        padding-left: 0;
    }

    .form-actions .el-button {
        width: 100%;
    }
}

@media (prefers-reduced-motion: reduce) {
    .point-card,
    .consultation-page ::v-deep .el-input__inner,
    .consultation-page ::v-deep .el-textarea__inner,
    .form-actions .el-button {
        transition: none !important;
    }
}
</style>
